export default class SessionManager {
   static PREFERENCIAS_STORAGE_KEY = 'preferenciasDoUsuario';

   static MONITORAMENTO_PREF_KEYS = [
      'Monitoramento.MostrarTemperatura',
      'Monitoramento.MostrarUmidade',
      'Monitoramento.MostrarPorta',
      'Monitoramento.SilenciarAlertaSonoro',
      'Monitoramento.MostrarInativosOuEmManutencao',
      'Monitoramento.MostrarSensoresInativos',
      'Monitoramento.MostrarSensoresComBateriaFraca',
      'Monitoramento.TipoDeVisualizacao',
      'Monitoramento.TipoDeVisualizacaoIcones',
      'Monitoramento.FiltrosDePredios',
      'Monitoramento.FiltrosDeLocais',
      'Monitoramento.FiltrosDeMonitorados',
      'Monitoramento.FiltrosDeCategorias',
   ];

   getLogin(tipoDeAcesso) {
        let result = JSON.parse(sessionStorage.getItem('usuario'));

      if (tipoDeAcesso === 'EMPRESA' && !result) {
         result = JSON.parse(localStorage.getItem('usuario'));
         if (result) {
            sessionStorage.setItem('usuario', JSON.stringify(result));
         }
      }

      if (tipoDeAcesso && result?.tipoDeAcesso !== tipoDeAcesso ) {         
         result = null;
      }

        return result;
    }

   normalizarPreferencias(preferencias) {
      if (!Array.isArray(preferencias)) {
         return [];
      }

      return preferencias
         .filter((i) => i)
         .map((i) => ({
            chave: i.chave != null ? i.chave : i.Chave,
            valor: i.valor != null ? i.valor : i.Valor,
         }))
         .filter((i) => i.chave);
   }

   setLogin(usuario, tipoDeAcesso) {
      if (!usuario) {
         return;
      }

      localStorage.setItem('lang', usuario.idioma || usuario.Idioma);

      if (tipoDeAcesso === 'EMPRESA') {         
         localStorage.setItem('usuario', JSON.stringify(usuario));
      }
      
        sessionStorage.setItem('usuario', JSON.stringify(usuario));
      
      // Se o login j� trouxe prefer�ncias, espelha no localStorage at� o GET /config.
      if (usuario.preferencias || usuario.Preferencias) {
         this.setPreferenciasLocal(usuario.preferencias || usuario.Preferencias);
      }
    }

   isAuthenticated(tipoDeAcesso) {
      let usuario = this.getLogin(tipoDeAcesso);
        return usuario && usuario.token && window.location.pathname !== '/login';
    }

    temAcessoARotina(rotina) {
        let result = this.isAuthenticated() && this.getLogin().rotinasAcessiveis.some((i) => i.id === rotina);
        return result;
    }

    isUsuarioTecnometrics() {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            result = usuario.isUsuarioTecnometrics && usuario.tipoDeAcesso === 'TECNOMETRICS';
        }
        return result;
    }

    isUsuarioDeEmpresa() {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            result =
                usuario.isUsuarioDeEmpresa ||
                (usuario.isUsuarioTecnometrics && usuario.tipoDeAcesso === 'TECNOMETRICS-SUPERVISOR');
        }
        return result;
    }

    isUsuarioDeConsultaDeEmpresa() {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            result = usuario.isUsuarioDeEmpresa && usuario.tipoDeAcesso === 'EMPRESA-CONSULTA';
        }
        return result;
    }

    isUsuarioTecnometricsSupervisor() {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (
            window.location.pathname !== '/login' &&
            usuario &&
            usuario.token &&
            usuario.isUsuarioTecnometrics &&
            usuario.empresa
        ) {
            return true;
        }
        return result;
    }

    isContratoMedTrackComMapa = () => {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            let isEmpresa =
                usuario.isUsuarioDeEmpresa ||
                (usuario.isUsuarioTecnometrics && usuario.tipoDeAcesso === 'TECNOMETRICS-SUPERVISOR');
            result = isEmpresa && usuario.tipoDeContrato === 1;
        }
        return result;
    };

    isContratoMedTrackSemMapa = () => {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            let isEmpresa =
                usuario.isUsuarioDeEmpresa ||
                (usuario.isUsuarioTecnometrics && usuario.tipoDeAcesso === 'TECNOMETRICS-SUPERVISOR');
            result = isEmpresa && usuario.tipoDeContrato === 2;
        }
        return result;
    };

    isContratoSenseTrack = () => {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            let isEmpresa =
                usuario.isUsuarioDeEmpresa ||
                (usuario.isUsuarioTecnometrics && usuario.tipoDeAcesso === 'TECNOMETRICS-SUPERVISOR');
            result = isEmpresa && usuario.tipoDeContrato === 3;
        }
        return result;
    };

    isContratoMedTrackExterno = () => {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            let isEmpresa =
                usuario.isUsuarioDeEmpresa ||
                (usuario.isUsuarioTecnometrics && usuario.tipoDeAcesso === 'TECNOMETRICS-SUPERVISOR');
            result = isEmpresa && usuario.tipoDeContrato === 4;
        }
        return result;
    };

    aceitouTermosDeUso() {
        let result = false;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        if (usuario && usuario.token && window.location.pathname !== '/login') {
            result = usuario.aceitouTermosDeUso;
        }
        return result;
    }

    salvarFiltrosDoMapaInicial(filtros) {
        localStorage.setItem('filtros_mapa_home', JSON.stringify(filtros));
    }

    filtrosDoMapaInicial() {
        return JSON.parse(localStorage.getItem('filtros_mapa_home'));
    }

   getPreferencias() {
      try {
         return this.normalizarPreferencias(JSON.parse(localStorage.getItem(SessionManager.PREFERENCIAS_STORAGE_KEY)));
      } catch (e) {
         return [];
      }
   }

   setPreferenciasLocal(preferencias) {
      const normalizadas = this.normalizarPreferencias(preferencias);
      localStorage.setItem(SessionManager.PREFERENCIAS_STORAGE_KEY, JSON.stringify(normalizadas));

      const login = this.getLogin();
      if (login) {
         login.preferencias = normalizadas;
         sessionStorage.setItem('usuario', JSON.stringify(login));
      }

      return normalizadas;
   }

   getPreferencia(chave, defaultValue = null) {
      const preferencia = this.getPreferencias().find((i) => i && i.chave === chave);
      return preferencia != null && preferencia.valor != null ? preferencia.valor : defaultValue;
   }

   montarPreferenciasComValor(chave, valor, preferenciasBase = null) {
      const preferencias = [...(preferenciasBase || this.getPreferencias())];
      const index = preferencias.findIndex((i) => i && i.chave === chave);

      if (valor == null) {
         if (index >= 0) {
            preferencias.splice(index, 1);
         }
      } else if (index >= 0) {
         preferencias[index] = { ...preferencias[index], chave, valor: String(valor) };
      } else {
         preferencias.push({ chave, valor: String(valor) });
      }

      return preferencias;
   }

   carregarPreferencias(api) {
      return api.get('/login/config', false, '', false).then((result) => {
         return this.setPreferenciasLocal(result);
      });
   }

   salvarPreferencias(api, preferencias = null) {
      const payload = this.normalizarPreferencias(preferencias != null ? preferencias : this.getPreferencias()).map(
         (i) => ({
            chave: i.chave,
            valor: i.valor,
         })
      );

      return api.post('/login/config', payload, false, true).then((result) => {
         return this.setPreferenciasLocal(Array.isArray(result) ? result : payload);
      });
   }

   limparSessionStorageDoMonitoramento() {
      SessionManager.MONITORAMENTO_PREF_KEYS.forEach((chave) => sessionStorage.removeItem(chave));
   }

   parseMapaDeFiltro(valor) {
      if (!valor) {
         return new Map();
      }
      try {
         return new Map(JSON.parse(valor));
      } catch (e) {
         return new Map();
      }
   }

   parseBoolPreferencia(valor, defaultValue) {
      if (valor == null) {
         return defaultValue;
      }
      return valor === true || valor === 'true';
   }

   parseIntPreferencia(valor, defaultValue) {
      if (valor == null || valor === '') {
         return defaultValue;
      }
      const parsed = parseInt(valor, 10);
      return Number.isNaN(parsed) ? defaultValue : parsed;
   }

   getFiltrosDoMonitoramento() {
      const tipoDeVisualizacao = this.parseIntPreferencia(
         this.getPreferencia('Monitoramento.TipoDeVisualizacao'),
         1
      );
      const tipoDeVisualizacaoIconesStored = this.getPreferencia('Monitoramento.TipoDeVisualizacaoIcones');
      const tipoDeVisualizacaoIcones =
         tipoDeVisualizacaoIconesStored != null
            ? this.parseIntPreferencia(tipoDeVisualizacaoIconesStored, tipoDeVisualizacao === 3 ? 1 : tipoDeVisualizacao)
            : tipoDeVisualizacao === 3
              ? 1
              : tipoDeVisualizacao;

      return {
         mostrarTemperatura: this.parseBoolPreferencia(
            this.getPreferencia('Monitoramento.MostrarTemperatura'),
            true
         ),
         mostrarUmidade: this.parseBoolPreferencia(this.getPreferencia('Monitoramento.MostrarUmidade'), true),
         mostrarPorta: this.parseBoolPreferencia(this.getPreferencia('Monitoramento.MostrarPorta'), true),
         silenciarAlertaSonoro: this.parseBoolPreferencia(
            this.getPreferencia('Monitoramento.SilenciarAlertaSonoro'),
            false
         ),
         mostrarInativosOuEmManutencao: this.parseBoolPreferencia(
            this.getPreferencia('Monitoramento.MostrarInativosOuEmManutencao'),
            false
         ),
         mostrarSensoresInativos: this.parseBoolPreferencia(
            this.getPreferencia('Monitoramento.MostrarSensoresInativos'),
            false
         ),
         mostrarSensoresComBateriaFraca: this.parseBoolPreferencia(
            this.getPreferencia('Monitoramento.MostrarSensoresComBateriaFraca'),
            false
         ),
         tipoDeVisualizacao,
         tipoDeVisualizacaoIcones,
         filtroDePredios: this.parseMapaDeFiltro(this.getPreferencia('Monitoramento.FiltrosDePredios')),
         filtroDeLocais: this.parseMapaDeFiltro(this.getPreferencia('Monitoramento.FiltrosDeLocais')),
         filtroDeMonitorados: this.parseMapaDeFiltro(this.getPreferencia('Monitoramento.FiltrosDeMonitorados')),
         filtroDeCategorias: this.parseMapaDeFiltro(this.getPreferencia('Monitoramento.FiltrosDeCategorias')),
      };
   }

   montarPreferenciasComFiltrosDoMonitoramento(filtros) {
      let preferencias = this.getPreferencias().filter(
         (i) => !SessionManager.MONITORAMENTO_PREF_KEYS.includes(i.chave)
      );

      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.MostrarTemperatura',
         filtros.mostrarTemperatura,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.MostrarUmidade',
         filtros.mostrarUmidade,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor('Monitoramento.MostrarPorta', filtros.mostrarPorta, preferencias);
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.SilenciarAlertaSonoro',
         filtros.silenciarAlertaSonoro,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.MostrarInativosOuEmManutencao',
         filtros.mostrarInativosOuEmManutencao,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.MostrarSensoresInativos',
         filtros.mostrarSensoresInativos,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.MostrarSensoresComBateriaFraca',
         filtros.mostrarSensoresComBateriaFraca,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.TipoDeVisualizacao',
         filtros.tipoDeVisualizacao,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.TipoDeVisualizacaoIcones',
         filtros.tipoDeVisualizacaoIcones,
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.FiltrosDePredios',
         JSON.stringify(Array.from(filtros.filtroDePredios.entries())),
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.FiltrosDeLocais',
         JSON.stringify(Array.from(filtros.filtroDeLocais.entries())),
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.FiltrosDeMonitorados',
         JSON.stringify(Array.from(filtros.filtroDeMonitorados.entries())),
         preferencias
      );
      preferencias = this.montarPreferenciasComValor(
         'Monitoramento.FiltrosDeCategorias',
         JSON.stringify(Array.from(filtros.filtroDeCategorias.entries())),
         preferencias
      );

      return preferencias;
   }

   salvarFiltrosDoMonitoramento(api, filtros) {
      const preferencias = this.montarPreferenciasComFiltrosDoMonitoramento(filtros);
      return this.salvarPreferencias(api, preferencias).then((result) => {
         this.limparSessionStorageDoMonitoramento();
         return result;
      });
   }

    getLang() {
        let result = localStorage.getItem('lang');

        if (!result || result === 'null') {
            var userLang = navigator.language || navigator.userLanguage;
            if (userLang === 'pt-BR' || userLang === 'en-US' || userLang === 'es' || userLang === 'de-DE') {
                result = userLang;
            } else {
                result = 'pt-BR';
            }
        }

        return result;
    }
}
